module.exports = __webpack_public_path__ + "static/media/split.840c26d0.svg";